export default __webpack_public_path__ + "static/media/cads_qr_logo.a4f8c038.png";